module.exports = __webpack_public_path__ + "a43fca592075fb8b31e1b05d48fbabac.MP3";